module.exports = __webpack_public_path__ + "media/images/logo-a29ba48370df5d514bee8b1211e2507e.png";